import { Controller } from '@hotwired/stimulus'

// Click-to-zoom overlay for file-upload image thumbnails.
export default class extends Controller {
  static values = { dialogLabel: String, closeLabel: String }

  open(event) {
    this.trigger = event.currentTarget

    const overlay = document.createElement('div')
    overlay.className = 'lightbox-overlay'
    overlay.setAttribute('role', 'dialog')
    overlay.setAttribute('aria-modal', 'true')
    overlay.setAttribute('aria-label', this.dialogLabelValue)
    overlay.addEventListener('click', (clickEvent) => {
      if (clickEvent.target === clickEvent.currentTarget) this.close()
    })

    const img = document.createElement('img')
    img.src = event.params.src
    img.alt = event.params.alt
    img.className = 'lightbox-overlay__image'

    const closeButton = document.createElement('button')
    closeButton.type = 'button'
    closeButton.className = 'lightbox-overlay__close'
    closeButton.setAttribute('aria-label', this.closeLabelValue)
    closeButton.textContent = '×'
    closeButton.addEventListener('click', () => this.close())

    overlay.append(img, closeButton)

    this.escHandler = (keyEvent) => {
      if (keyEvent.key === 'Escape') this.close()
    }
    document.addEventListener('keydown', this.escHandler)

    document.body.appendChild(overlay)
    this.overlay = overlay
    closeButton.focus()
  }

  close() {
    this.overlay?.remove()
    this.overlay = null
    document.removeEventListener('keydown', this.escHandler)
    this.trigger?.focus()
  }

  disconnect() {
    this.close()
  }
}
